import { useTranslation } from 'react-i18next';
import {
  NOTIFICATIONDELIVERYSTATUS_AWAITING,
  NOTIFICATIONDELIVERYSTATUS_FAILED,
  NOTIFICATIONDELIVERYSTATUS_SUCCESSFUL,
  NOTIFICATIONDELIVERYSTATUS_UNKNOWN,
} from '../constants/api';

const NotificationStatusTag = ({ status, isSent }) => {
  const { t: translator } = useTranslation();

  const renderTag = () => {
    if (!isSent) {
      return (
        <div className="status-tag-child status-tag-child__notification-not-sent">
          {translator('notificationStatus.notSent')}
        </div>
      );
    }
    switch (status) {
      case NOTIFICATIONDELIVERYSTATUS_AWAITING:
        return (
          <div className="status-tag-child status-tag-child__notification-awaiting">
            {translator('notificationStatus.awaiting')}
          </div>
        );
      case NOTIFICATIONDELIVERYSTATUS_SUCCESSFUL:
        return (
          <div className="status-tag-child status-tag-child__notification-successful">
            {translator('notificationStatus.successful')}
          </div>
        );
      case NOTIFICATIONDELIVERYSTATUS_FAILED:
        return (
          <div className="status-tag-child status-tag-child__notification-failed">
            {translator('notificationStatus.failed')}
          </div>
        );
      case NOTIFICATIONDELIVERYSTATUS_UNKNOWN:
      default:
        return (
          <div className="status-tag-child status-tag-child__notification-unknown">
            {translator('notificationStatus.unknown')}
          </div>
        );
    }
  };

  return <div className="status-tag">{renderTag()}</div>;
};

export { NotificationStatusTag };
